var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeizure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 200,
    viewBox: "0 0 218 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_7363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14478 49.4668V144.113C1.14478 146.054 2.18294 147.862 3.87476 148.823L83.1019 194.579C84.7937 195.559 86.87 195.559 88.5426 194.579L167.77 148.823C169.462 147.842 170.5 146.054 170.5 144.113V49.4668L85.8127 98.3565L1.14478 49.4668Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14502 49.4669L85.8321 0.577148L170.519 49.4669L85.8321 98.3759L1.14502 49.4669Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8469 68.3653L118.515 19.4756L137.586 30.4916L52.8991 79.4006L52.8606 116.005L33.8276 105.028L33.8469 68.3653Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.832 98.3755V194.848",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6047 158.935V175.104L44.4785 157.974V141.806L73.6047 158.935Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.582 200.165C195.861 200.165 217.165 178.861 217.165 152.582C217.165 126.303 195.861 105 169.582 105C143.303 105 122 126.303 122 152.582C122 178.861 143.303 200.165 169.582 200.165Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.815 151.204H157.593C155.609 151.204 154 152.813 154 154.797V167.408C154 169.392 155.609 171 157.593 171H182.815C184.799 171 186.407 169.392 186.407 167.408V154.797C186.407 152.813 184.799 151.204 182.815 151.204Z",
    stroke: "white",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.204 151.204V144C161.204 139.028 165.232 135 170.204 135C175.175 135 179.204 139.028 179.204 144V151.204",
    stroke: "white",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_7363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.303,
    height: 200,
    fill: "white",
    transform: "translate(0.568115)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeizure);
export default __webpack_public_path__ + "static/media/seizure.357e93ce3a4aa8bb8c03ac910fd1c966.svg";
export { ForwardRef as ReactComponent };